interface LocationProps {
  customClassName?: string
}

export const Location = ({ customClassName }: LocationProps) => {
  return (
    <svg width="17" height="24" viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={customClassName}>
      <g id="Location Icon">
        <path
          id="Vector"
          d="M8.5 0C3.79198 0 0 3.85125 0 8.63286C0 13.7823 5.36842 20.879 7.58396 23.5619C8.07393 24.146 8.94737 24.146 9.43734 23.5619C11.6316 20.8573 17 13.7606 17 8.63286C17 3.87289 13.1867 0 8.5 0ZM8.5 11.7268C6.81704 11.7268 5.45363 10.3421 5.45363 8.63286C5.45363 6.9236 6.81704 5.53888 8.5 5.53888C10.183 5.53888 11.5464 6.9236 11.5464 8.63286C11.5464 10.3421 10.1617 11.7268 8.5 11.7268Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
